import { ValueTypeCategory } from 'common/types/summaryDefinitions/valueTypes/valueType';

export const CATEGORY_LABELS: Record<ValueTypeCategory, string> = {
  identifier: 'Default Columns',
  dates: 'Dates',
  ownership: 'Ownership',
  values: 'Values',
  metrics: 'Metrics',
  cap_table: 'Cap Table',
  financials: 'Financials',
  cash_flows: 'Cash Flows',
  valuation: 'Valuation',
  breakpoints: 'Breakpoints',
  process: 'Process Management',
  custom: 'Custom',
};

export const CATEGORY_ORDER: ValueTypeCategory[] = [
  'identifier', 'dates', 'ownership', 'values', 'metrics',
  'cap_table', 'financials', 'cash_flows', 'valuation', 'breakpoints', 'process', 'custom',
];
